export default __webpack_public_path__ + "007ca18d2cbae7381b3912c3f3ebbf59.woff2";